import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import HomePage from './components/HomePage';
import AdminDashboard from './Admin/AdminDashboard';
import Hospital from './Admin/Hospital';
import AdminHospitalDetails from './Admin/AdminHospitalDetails';
import Reports from './components/Reports';
import HospitalDashboard from './Hospital/HospitalDashboard';
import Doctors from './Hospital/Doctors';
import PatientDetails from './components/PatientDetails';
import ProtectedRoute from './components/ProtectedRoutes';
import 'antd/dist/reset.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<HomePage />} />
          <Route path="/" element={<Navigate to="/login" />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/dashboard/hospital" element={<Hospital />} />
            <Route path="/dashboard/hospital/:id" element={<AdminHospitalDetails />} />
            <Route path="/dashboard/reports" element={<Reports />} />
            <Route path="/hospital-dashboard" element={<HospitalDashboard />} />
            <Route path="/hospital/doctors" element={<Doctors />} />
            <Route path="/hospital/reports/patient-details" element={<PatientDetails />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
